import { uiInvoiceInitialState } from './invoices'

export const uiModel = {
  invoices: uiInvoiceInitialState,
}
